import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Globle } from 'src/assets/globle';
import { PaymentRequest } from '../paymentrequest.model';

@Component({
  selector: 'app-paymentrequestdetails',
  templateUrl: './paymentrequestdetails.component.html',
  styleUrls: ['./paymentrequestdetails.component.css'],
  queries: {
    contentRef: new ViewChild("ModalViewImg"),
  },
})
export class PaymentrequestdetailsComponent implements OnInit {

  @Input() orderDetails = {} as PaymentRequest;
  orderType: string = "";
  imgPath!: string
  public contentRef!: TemplateRef<any>;
  constructor(private dialog: MatDialog, private gloubl: Globle) {

  }

  ngOnInit(): void {
    this.imgPath = this.gloubl.imgPath;

    if (this.orderDetails.serviceClass == 1) {
      switch (this.orderDetails.serviceNo) {
        case 1:
          this.orderType = "حسن سيرة وسلوك";
          break;
        case 2:
          this.orderType = "عدم محكومية";
          break;
        case 3:
          this.orderType = "رسوم المكرمة";
          break;
        case 4:
          this.orderType = "مكرمة جيش";
          break;
        case 5:
          this.orderType = "قبول موحد";
          break;
        default:
          this.orderType = "رسوم جامعة";
          break;
      }
    }
    else {
      switch (this.orderDetails.serviceNo) {
        case 1:
          this.orderType = "فاتورة كهرباء";
          break;
        case 2:
          this.orderType = "فاتورة مياه";
          break;
        case 3:
          this.orderType = "اتصالات";
          break
        default:
          this.orderType = "مخالفة كمامة";
          break;
      }
    }
  }

  viewImage() {
    this.openDialogImg();
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  openDialogImg(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '1000px',
      height: '1000px'
    });
  }

}
